import Axios from 'axios'
import config from '../config'


export default (() => {
  // A preconfigured axios instance
  // Using this instead of global axios prevents conflicts with other node modules
  const instance = Axios.create({
    baseURL: config.API_HOST,
    timeout: 10000,
    responseType: 'json',
    xsrfHeaderName: null, // server passes token in a cookie
    xsrfCookieName: null, // but this option doesn't work outside of the browser environment
    headers: {
      'Content-Type': 'application/json',
      'Cookie': null, // so we will manually extract cookies from the response header
    },
  })

  instance.defaults.withCredentials = true

  instance.interceptors.request.use( config => {
    // add jwt accessToken to auth header if present in localstorage
    const accessToken = window.localStorage.getItem( 'accessToken' )
    if ( accessToken ) {
      config.headers[ 'Authorization' ] = `Bearer ${ accessToken }`
    }
    // add current hq header if present in localstorage
    const currentHq = window.localStorage.getItem( 'currentHq' )
    if ( currentHq ) {
      config.headers[ 'Current-Hq' ] = currentHq
    }
    return config
  }, error => {
    return Promise.reject( error )
  })

  instance.interceptors.response.use( response => {
    // extract jwt from response data and store to localstorage
    if ( response && response.data ) {
      const { accessToken, refreshToken } = response.data
      if ( accessToken ) {
        window.localStorage.setItem( 'accessToken', accessToken )
        delete response.data.accessToken
      }
      if ( refreshToken ) {
        window.localStorage.setItem( 'refreshToken', refreshToken )
        delete response.data.refreshToken
      }
    }
    // Manually extract cookies which may contain the CSRF token
    if ( response.headers['set-cookie']) {
      instance.defaults.headers['Cookie'] = response.headers['set-cookie']
    }

    return Promise.resolve( response && response.data )
  },
  error => {
    return Promise.reject( error )
  })

  return instance
})()
